import React from "react";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import { USER_TYPE } from "../constant";
import CardContainer from "../CardContainer/index";
import "./accountMainContent.scss";
import { Spinner } from "react-bootstrap";

const AccountMainContent = (props) => {
  const { contentLoading } = props;

  const accountBody = () => {
    return (
      <div className={"dashboard-accounts-main"}>
        <div
          className={
            "mt-2 main-cont " +
            (localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE) === USER_TYPE.STAFF
              ? "scroll-staff"
              : "scroll")
          }
        >
          {props.doctorAccount.length !== 0
            ? props.doctorAccount?.map((data, indx) => {
                return (
                  <>
                    <CardContainer
                      doctorData={data}
                      key={data?.doctor_id ? data?.doctor_id : indx}
                      updateRoomNumberCallBack={props.updateRoomNumberCallBack}
                      handleEditProfileShow={props.handleEditProfileShow}
                      handleAdminEditProfileShow={
                        props.handleAdminEditProfileShow
                      }
                      handleShareLinkClick={props.handleShareLinkClick}
                      handleOnlineClick={props.handleOnlineClick}
                      handleInClinicClick={props.handleInClinicClick}
                      roomDetails={props.roomDetails}
                      toggleRoomStatus={props.toggleRoomStatus}
                    />
                  </>
                );
              })
            : null}
          {contentLoading && (
            <div className="accounts-spinner-container">
              <Spinner animation="border" className="accounts-spinner" />
            </div>
          )}
        </div>
      </div>
    );
  };

  return <div className={"dashboard-accounts-main"}>{accountBody()}</div>;
};

export default AccountMainContent;
